// menu
// ***********************************************
(() => {
  const mbtn = document.querySelector('.js-mbtn');
  const mbtn2 = document.querySelector('.js-mbtn2');
  const body = document.body;

  if (!mbtn) return;

  mbtn.addEventListener('click', () => {
    body.classList.toggle('is-menuOpen');
  });
  mbtn2.addEventListener('click', () => {
    body.classList.toggle('is-menuOpen2');
  });
})();

// otherMenu topset
// ***********************************************
(function() {

  const $otherMenu = $('.js-otherMenu');
  const $header = $('.js-header');
  let headerHeight;
  function otherMenuTopSet() {
    headerHeight = $header.outerHeight();
    $otherMenu.css('top', headerHeight);
  }

  otherMenuTopSet();

  $(window).on('load resize', function(){
    otherMenuTopSet();
  });

}());
